import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { ShortEncryptorService } from '../../../services/short-encryptor.service';
import emailjs from '@emailjs/browser';

@Component({
  selector: 'app-view-kyc',
  imports: [CommonModule, FormsModule],
  providers: [DatePipe],
  templateUrl: './view-kyc.component.html',
  styleUrl: './view-kyc.component.scss',
})
export class ViewKycComponent {
  @Input() user: any;

  datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  loading = false;
  selectedModules: any = [];
  modules: any = [];
  progress: number = 0;

  formData = {
    institute: {
      org_id: '', 
      inst_code: '', 
      inst_name: '', 
      inst_type: '', 
      website: '', 
      reg_no: '', 
      gst_no: '', 
      phone_no: '', 
      address: '', 
      city: '', 
      state: '', 
      pincode: '', 
      country: '', 
      logo: '', 
      banner: '', 
      agr_consent: false,
      agr_name: '',
      agr_desi: '',
      agr_lickey: '',
      reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      is_active: true,
      district: ''
    },

    contacts: [
      {
        person_name: '', 
        person_desi: '', 
        department: '', 
        mobile_no1: '', 
        mobile_no2: '', 
        email_id: '', 
        is_primary: false, 
        is_active: true
      }
    ],

    billing: {
      billing_name: '', 
      gst_no: '', 
      gst_state_code: '', 
      address: '', 
      city: '', 
      state: '', 
      pincode: '', 
      reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      is_active: true,
      district: ''
    },

    organization: {
      org_code: '', 
      org_name: '', 
      org_address: '', 
      org_city: '', 
      org_state: '',
      org_pincode: '', 
      reg_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      is_active: true,
      org_exists: false,
      district: ''
    },

    package: {
      pkg_code: '',
      bill_cycle: '', 
      std_counts: 0, 
      imp_amount_ot: 0.00, 
      pkg_amount: 0.00, 
      base_amount: 0.00, 
      module_amount: 0.00, 
      discount_amount: 0.00, 
      net_amount: 0.00, 
      tax_amount: 0.00, 
      total_amount: 0.00, 
      paid_amount: 0.00, 
      bal_amount: 0.00, 
      coupon_code: '', 
      paid_offline: true, 
      pay_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
      start_date: '', 
      exp_date: '', 
      selected_modules: [],
      auto_renew: false, 
      save_paym: false, 
      is_active: true
    },

    agreement: {
      consent: false,
      name: '',
      designation: '',
      cur_date: new Date().toISOString().split('T')[0]
    }
  };

  pricing: any = {
    baseAmount: 0,
    discountAmount: 0,
    subtotal: 0,
    taxAmount: 0,
    totalAmount: 0
  };

  licKey: string = '';
  instID: string = '';
  orgID: string = '';
  searchQuery: string = '';
  institutes: any = [];
  existedInsts: any = null;
  orgs: any = [];
  existedOrgs: any = null;
  reNewAlert: boolean = false;

  constructor(public dataService: DataService, private shCrypt: ShortEncryptorService) {
    //
  }

  ngOnInit() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      // erp_rem = this.dataService.deCodeUser(erp_rem);

      const curDate: Date = new Date();
      const expDate: Date = new Date(erp_rem.exp_date);
      const dayRemains = this.dataService.getDaysDiff(curDate, expDate);

      if(dayRemains < 15) {
        this.reNewAlert = true;
      } else {
        this.reNewAlert = false;
      }
    }

    this.loadOrgs();
  }

  ngOnChanges() {
    let curDate: any = new Date();
    curDate = this.datePipe.transform(curDate, 'yyyy-MM-dd')?.toString();

    // For DEMO/Trial Users
    if(this.user && this.user.pref_date && !this.user.schema) {
      this.genCustomInstID();

      this.formData.organization.org_code = 'DEMO';
      this.formData.organization.org_name = 'DEMO';
      this.formData.institute.org_id = 'DEMO';

      this.formData.institute.inst_name = this.user.inst_name;
      this.formData.institute.inst_type = this.user.inst_type;
      this.formData.institute.website = this.user.inst_website;
      this.formData.institute.phone_no = this.user.mobile_no;
      this.formData.institute.address = this.user.address;
      this.formData.institute.city = this.user.city;
      this.formData.institute.state = this.user.state;
      this.formData.institute.pincode = this.user.pincode;

      if(this.formData.institute.state) {
        this.formData.institute.district = this.dataService.getDist(this.formData.institute.state);
      }

      this.formData.contacts[0].person_name = this.user.full_name;
      this.formData.contacts[0].person_desi = 'erp';
      this.formData.contacts[0].mobile_no1 = this.user.mobile_no;
      this.formData.contacts[0].mobile_no2 = this.user.mobile_no;
      this.formData.contacts[0].email_id = this.user.email_id;
      this.formData.contacts[0].is_primary = true;

      this.formData.package.pkg_code = 'p4';
      this.formData.package.bill_cycle = 'days';
      this.formData.package.std_counts = this.user.student_counts;
      // this.formData.package.selected_modules = ["ALL"];

      this.formData.institute.agr_lickey = '';
    }

    // const userx = this.shCrypt.decrypt(this.user.user_name);
    // if(userx == 'trial' && this.user.is_active) {
    // }

    if (this.user?.kyc_data) {
      this.formData = this.user.kyc_data;
      this.formData.package.pay_date = curDate;
      this.formData.package.start_date = curDate;
      this.formData.organization.reg_date = curDate;

      // this.genCustomInstID();
    }

    this.getExpiry(curDate);
  }

  doInstSearch() {
    this.existedInsts = this.searchByName(this.institutes, "inst_name", this.formData.institute.inst_name);
  }

  doOrgSearch() {
    this.existedOrgs = this.searchByName(this.orgs, "org_name", this.formData.organization.org_name);
  }

  loadOrgs() {
    // this.loading = true;
    // // Loading for search purpose
    // this.dataService.getAllRecords('institutes').then((res: any) => {
    //   this.institutes = res;
    //   this.loading = false;
    // });
    this.loading = true;
    // Loading for search purpose
    this.dataService.getAllRecords('organizations').then((res: any) => {
      this.orgs = res;
      this.loading = false;
    });
  }

  selectInst(inst: any) {
    this.formData.institute = inst;
    if(inst.state) {
      this.formData.institute.district = this.dataService.getDist(inst.state);
    }
    this.instID = inst.inst_code;
  }

  selectOrg(org: any) {
    this.formData.organization = org;
    if(org.state) {
      this.formData.organization.district = this.dataService.getDist(org.state);
    }
    this.orgID = org.org_code;
    this.formData.institute.org_id = this.orgID;
  }

  genLicKey() {
    this.licKey = this.dataService.generateRandomKey();
    this.formData.institute.agr_lickey = this.licKey;
  }

  genCustomInstID() {
    if(this.formData.institute.org_id == "DEMO") return;
    
    const numbers = '0123456789';
    const customCode1 = this.dataService.getUUID(4, numbers);
    const customCode2 = this.dataService.getUUID(4, numbers);

    this.orgID = customCode1;
    this.instID = customCode2;

    this.formData.organization.org_code = this.orgID;
    this.formData.institute.org_id = this.orgID;

    if(!this.formData.institute.inst_code) {
      this.formData.institute.inst_code = this.instID;
    }
  }

  getPackName() {
    const pcode: string = this.formData.package.pkg_code;
    return this.dataService.getPackageName(pcode);
  }

  searchByName(dataList: any, dataField: string, searchInput: string) {
    // Return all data if search input is empty
    if (!searchInput.trim()) return dataList;

    // Convert input to lowercase and split by spaces into individual keywords
    const keywords = searchInput.toLowerCase().split(/\s+/).filter(word => word.length > 0);

    // Filter the array: return true if ANY keyword matches the name
    return dataList.filter((item: any) => {
      const name = item[dataField].toLowerCase();
      return keywords.some(keyword => name.includes(keyword));
    });
  }

  getExpiry(curDate: any) {
    // let curDate: any = new Date();
    const mDays: number = 30;
    const billingCycle = this.formData.package.bill_cycle || 'days';
    let dayCounts: number = 0;

    if (billingCycle == 'days') {
      dayCounts = 7;
    } else if (billingCycle == 'Monthly') {
      dayCounts = mDays;
    } else if (billingCycle == 'Quarterly') {
      dayCounts = mDays * 3;
    } else if (billingCycle == 'Semi Annually') {
      dayCounts = mDays * 6;
    } else {
      dayCounts = mDays * 12;
    }

    let expDate: any = this.dataService.getFutureDate(curDate, dayCounts);

    curDate = this.datePipe.transform(curDate, 'yyyy-MM-dd')?.toString();
    expDate = this.datePipe.transform(expDate, 'yyyy-MM-dd')?.toString();

    this.formData.package.pay_date = curDate;
    this.formData.package.start_date = curDate;
    this.formData.package.exp_date = expDate;
  }

  addContact() {
    this.formData.contacts.push({
      person_name: '', 
      person_desi: '', 
      department: '', 
      mobile_no1: '', 
      mobile_no2: '', 
      email_id: '', 
      is_primary: false, 
      is_active: true
    });
  }

  async removeContact(index: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
      if (this.formData.contacts.length > 1) {
        this.formData.contacts.splice(index, 1);
      }
    } else {
        console.log('Deletion cancelled');
    }
  }

  setPrimary(index: number) {
    this.formData.contacts.forEach((c, i) => {
      c.is_primary = i === index;
    });
  }

  updatePackagePrice() {
    const pkg = this.formData.package.pkg_code;
    const type = this.formData.package.bill_cycle;
    let amount = 0;

    if (pkg === 'p1') {
      amount = 500;
    } else if (pkg === 'p2') {
      amount = 800;
    } else if (pkg === 'p3') {
      amount = 1000;
    } else if (pkg === 'p4') {
      amount = 100;
    }

    if (type === 'Quarterly') {
      amount *= 3;
    } else if (type === 'Semi Annually') {
      amount *= 6;
      // amount *= 0.9;
    } else if (type === 'Annually') {
      amount *= 12;
      // amount *= 0.9;
    }

    this.formData.package.base_amount = amount;
  }

  calculateExpiry() {
    const startDate = new Date(this.formData.package.start_date);

    if (!startDate) return;

    const expiry = new Date(startDate);

    switch (this.formData.package.bill_cycle) {
      case 'Monthly':
        expiry.setMonth(expiry.getMonth() + 1);
        break;

      case 'Quarterly':
        expiry.setMonth(expiry.getMonth() + 3);
        break;

      case 'Annually':
        expiry.setFullYear(expiry.getFullYear() + 1);
        break;
    }

    this.formData.package.exp_date = expiry.toISOString().split('T')[0];
  }

  // toggleModule(code: string): void {
  toggleModule(code: string) {
    const current = [...this.selectedModules];
    const idx = current.indexOf(code);
    if (idx > -1) current.splice(idx, 1);
    else current.push(code);
    this.selectedModules = current;
    this.calculatePricing();
  }

  // async calculatePricing(): Promise<void> {
  calculatePricing() {
    // const result = await this.subService.calculatePricingFromDB(
    //   this.selectedModules(),
    //   this.studentCount,
    //   this.billingCycle
    // );

    // if (result.data) {
    //   let pricing = { ...result.data };

    //   // Apply coupon discount
    //   if (this.appliedCoupon()) {
    //     let discount = 0;
    //     if (this.appliedCoupon().discount_type === 'percentage') {
    //       discount = pricing.baseAmount * (this.appliedCoupon().discount_value / 100);
    //     } else {
    //       discount = this.appliedCoupon().discount_value;
    //     }
    //     pricing.discountAmount = Math.min(discount, pricing.baseAmount);
    //     pricing.subtotal = pricing.baseAmount - pricing.discountAmount + pricing.configurationCharge + pricing.trainingCharge;
    //     pricing.taxAmount = pricing.subtotal * 0.18;
    //     pricing.totalAmount = pricing.subtotal + pricing.taxAmount;
    //   }

    //   this.pricing.set(pricing);
    // }
  }

  isTermsValid(): boolean {
    return !!(
      this.formData?.agreement?.name &&
      this.formData?.agreement?.designation &&
      this.formData?.agreement?.cur_date &&
      this.formData?.agreement?.consent
    );
  }

  onBoardingSetup() {
    let newDbInfo: any = {};
    const curYear = new Date().getFullYear();
    const curMonth = new Date().getMonth();
    this.dataService.onBoarding = true;
    this.progress = 1;

    newDbInfo = {
      erp_key: this.formData.organization.org_code + '-' + this.formData.institute.inst_code,
      db_name: 'erpdb_' + this.formData.organization.org_code, 
      schema_name: 'inst_' + this.formData.institute.inst_code + '_' + (curMonth < 3 ? curYear-1 : curYear),
      gen_pub: true
    }

    this.dataService.addNewRecord('new-schema', newDbInfo).subscribe({
      next: (response) => {
        if(response.success) {
          if(this.user && this.user.pref_date) {
            this.addNewDataInNewSchema();     // For DEMO/Trial Users
          } else {
            this.progress = 10;
            this.loading = true;
            const orgData: any = Object.assign({}, this.formData.organization);
            delete orgData.district;
            delete orgData.org_exists;
            this.dataService.addNewRecord('organizations', orgData, true).subscribe({
              next: (response) => {
                console.log('Organization Response: ', response);
                this.loading = false;
                this.progress = 40;
                this.addNewDataInNewSchema();
              },
              error: (error) => {
                console.error('Error received in component:', error);
                this.loading = false;
                this.dataService.onBoarding = false;
              }
            });
          }
        }
      },
      error: (error) => {
        this.loading = false;
        this.dataService.onBoarding = false;
        console.error('Error received in new DB: ', error);
      }
    });
  }

  addNewDataInNewSchema() {
    this.loading = true;

    this.dataService.addNewRecord('new-schema/new-data', this.formData).subscribe({
      next: (response) => {
        this.progress = 100;
        console.log('Institute Response: ', response);

        for(let i=0; i<this.formData.contacts.length; i++) {
          const contact: any = this.formData.contacts[i];
          if(contact.person_desi=='erp' && contact.email_id) {
            this.sendEmail(contact.email_id);
            break;
          }
        }

        this.loading = false;
        this.dataService.onBoarding = false;
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
        this.dataService.onBoarding = false;
      }
    });
  }

  sendEmail(emailTo: string) {
    this.loading = false;
    this.dataService.onBoarding = false;
    const template_code: string = this.formData.institute.org_id == 'DEMO' ? 'template_7wn7isx' : 'template_3nd27gp';
    const urlic_key: string = this.formData.institute.org_id == 'DEMO' ? this.formData.institute.agr_lickey : 'trial';

    emailjs.send(
      'service_5ak8cck',
      template_code, {
        email: emailTo,
        lic_key: urlic_key,
        erp_key: (this.formData.organization.org_code + '-' + this.formData.institute.inst_code).toString()
      },
      'oL3_6kGTB0jKdmSUW'
    )
    .then(() => {
      console.log('Email Sent at '+emailTo);
      if(this.formData.institute.org_id != 'DEMO' && this.user.schema) {
        this.trialUnSet();
      }
    })
    .catch(error => {
      console.error(error);
    });
  }

  trialUnSet() {
    const schema: any = this.user.schema;
		this.loading = true;
    this.dataService.getSingleRecord('unset-schema', schema).then((res: any) => {
      if(res) {
        this.loading = false;
        this.ngOnInit();
      }
    });
	}

  fetchInst() {
    this.formData.billing.billing_name = this.formData.institute.inst_name;
    this.formData.billing.gst_no = this.formData.institute.gst_no;
    // this.formData.billing.gst_state_code = '';
    this.formData.billing.address = this.formData.institute.address;
    this.formData.billing.state = this.formData.institute.state;
    this.formData.billing.city = this.formData.institute.city;
    this.formData.billing.pincode = this.formData.institute.pincode;
  }
}
